export default "__VITE_ASSET__C9Dd$o2m__"